import {
  getIndexPagination,
  getIndexPaginationSearchParams,
  normalizeIndexPagination,
  INDEX_PAGE_SIZES,
} from '@shared/lib/pagination';
import { PageContainer } from '@shared/ui';
import { useEffect, useState } from 'react';
import { PaginateType, type SortQuery } from '@shared/types';
import { useGetAIConstants } from '@entities/aiConstants';
import { AIConstantsList } from '@features/AIConstants';
import { useSearchParams } from 'react-router';

export const AIConstantsListPage = () => {
  const [sort, setSort] = useState<SortQuery>({});

  const [searchParams, setSearchParams] = useSearchParams();

  const { page, pageSize } = getIndexPagination(searchParams);

  useEffect(() => {
    const normalized = normalizeIndexPagination(searchParams);
    if (normalized.toString() !== searchParams.toString()) {
      setSearchParams(normalized, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const setPage = (nextPage: number) => {
    setSearchParams(
      getIndexPaginationSearchParams(searchParams, nextPage, pageSize)
    );
  };
  const setPageSize = (size: number) => {
    setSearchParams(getIndexPaginationSearchParams(searchParams, 1, size));
  };

  const handleSortChange = (field: string, direction?: 'asc' | 'desc') => {
    if (!direction) {
      const newSort = { ...sort };
      delete newSort[field];

      setSort(newSort);
      return;
    }

    setSort({
      [field]: direction,
    });
  };

  const {
    data: aiConstants,
    isLoading,
    isFetching,
  } = useGetAIConstants({
    filter: {},
    sort,
    perPage: pageSize,
    page,
    paginate: PaginateType.DEFAULT,
  });

  return (
    <PageContainer title='Константы ИИ'>
      <AIConstantsList
        aiConstants={aiConstants?.data || []}
        page={page}
        setPage={setPage}
        onRecordsPerPageChange={setPageSize}
        recordsPerPageOptions={INDEX_PAGE_SIZES}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        currentSort={sort}
        isLoading={isLoading || isFetching}
        totalRecords={aiConstants?.pagination?.total || 0}
      />
    </PageContainer>
  );
};
